export default "__VITE_ASSET__0ad8054c__"